import graphql from "babel-plugin-relay/macro";
import { confirmAccountMutation, confirmAccountMutationResponse } from "generatedQueries/confirmAccountMutation.graphql";
import { commitMutation, IEnvironment, PayloadError } from "relay-runtime";

export type ConfirmAccountFormValues = {
    canDiscloseToPublic: string | null;
    isSubscribedToShelterNewsletter: string | null;
}

export interface IConfirmAccountMutationVariables {
    canDiscloseToPublic: boolean | null;
    isSubscribedToShelterNewsletter: boolean | null;
}

const mutation = graphql`
    mutation confirmAccountMutation($canDiscloseToPublic: Boolean!, $isSubscribedToShelterNewsletter: Boolean!) {
        updateLicensingAllowedDisclosureGroup(canDiscloseToPublic: $canDiscloseToPublic) {
            id
            ...Header_account
        }
        updateIsSubscribedToShelterNewsletter(isSubscribedToShelterNewsletter: $isSubscribedToShelterNewsletter) {
            id
            ...Header_account
        }
    }`;

export function confirmAccount(
    environment: IEnvironment,
    variables: IConfirmAccountMutationVariables | ConfirmAccountFormValues,
    onCompleted: (response: confirmAccountMutationResponse, errors?: PayloadError[] | null) => void,
    onError: (error: Error) => void
) {
    return commitMutation<confirmAccountMutation>(
        environment,
        {
            mutation,
            onCompleted,
            onError,
            variables: {
                canDiscloseToPublic: toBoolean(variables.canDiscloseToPublic),
                isSubscribedToShelterNewsletter: toBoolean(variables.isSubscribedToShelterNewsletter),
            },
        }
    );

    function toBoolean(value: boolean | string | null): boolean {
        if (typeof value === "boolean") {
            return value;
        }

        if (typeof value === "string") {
            return value === "true";
        }

        return false;
    }
}
